export default {
    company: 'Company',
    trucksCount: 'The total number\nof trucks placed',
    trucksCountTooltip: 'How many trucks in total the\u00A0carrier has posted for the specified direction. The\u00A0higher the\u00A0value, the more likely the participant will be\u00A0interested in your load.',
    searchCount: 'Total loads searched',
    searchCountTooltip: 'How many times the\u00A0carrier has searched for loads in the specified direction. The\u00A0higher the\u00A0value, the more likely the participant will be\u00A0interested in your load.',
    actualTrucks: 'Trucks\nready to\u00A0be loaded',
    actualTrucksTooltip: 'How many trucks right now are ready to\u00A0be\u00A0loaded in the\u00A0specified direction.',
    canSelectAndInvite: 'Now you can select all carriers and invite them to your platform or add them to your list',
};
